export default __webpack_public_path__ + "static/media/1490.2ccdb59d.png";